import { Timestamp } from "firebase/firestore";
import { TransactionCategory } from "../../types/budgethelper";
import RestaurantIcon from '@mui/icons-material/Restaurant';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import MovieIcon from '@mui/icons-material/Movie';
import HomeIcon from '@mui/icons-material/Home';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

export function formatDateKey(timestamp: Timestamp): string {
  const date = timestamp.toDate();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatDateHeader(dateKey: string): string {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayYear = today.getFullYear();
  const todayMonth = String(today.getMonth() + 1).padStart(2, '0');
  const todayDay = String(today.getDate()).padStart(2, '0');
  const todayKey = `${todayYear}-${todayMonth}-${todayDay}`;

  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayYear = yesterday.getFullYear();
  const yesterdayMonth = String(yesterday.getMonth() + 1).padStart(2, '0');
  const yesterdayDay = String(yesterday.getDate()).padStart(2, '0');
  const yesterdayKey = `${yesterdayYear}-${yesterdayMonth}-${yesterdayDay}`;

  if (dateKey === todayKey) return "Today";
  if (dateKey === yesterdayKey) return "Yesterday";

  const [year, month, day] = dateKey.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" });
}

export function formatTime(timestamp: Timestamp): string {
  return timestamp.toDate().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function getCategoryIcon(category?: TransactionCategory): React.ReactElement {
  switch (category) {
    case TransactionCategory.FOOD:
      return <RestaurantIcon />;
    case TransactionCategory.GROCERY:
      return <LocalGroceryStoreIcon />;
    case TransactionCategory.SHOPPING:
      return <ShoppingBagIcon />;
    case TransactionCategory.ENTERTAINMENT:
      return <MovieIcon />;
    case TransactionCategory.TRANSPORT:
      return <DirectionsCarIcon />;
    case TransactionCategory.UTILITIES:
      return <HomeIcon />;
    case TransactionCategory.HEALTHCARE:
      return <LocalHospitalIcon />;
    default:
      return <MoreHorizIcon />;
  }
}
